import { Selector } from '@snapi/luxury';
import { ResearchCategory, ResearchFilter } from '@snapi/types';

export interface ReportResearchFilterProps {
  conditions: string[];
  filter: ResearchFilter;
  onChange(filter: ResearchFilter): void;
}

export const ReportResearchFilter: React.FC<ReportResearchFilterProps> = ({
  conditions,
  filter,
  onChange,
}) => {
  const handleCategoryChange = (categories: string[]) => {
    const selected = categories.reduce(
      (agg: ResearchCategory[], category) =>
        agg.concat([category as ResearchCategory]),
      []
    );

    onChange({ ...filter, categories: selected });
  };

  const handleAssociationsChanged = (associations: string[]) => {
    onChange({ ...filter, conditions: associations });
  };

  return (
    <div className="flex flex-col p-3 bg-white rounded-[10px] w-[280px]">
      <Selector
        title="Bacteria"
        selected={filter.categories}
        options={[
          ResearchCategory.protective,
          ResearchCategory.disruptive,
          ResearchCategory.neutral,
          ResearchCategory.other,
        ]}
        onChange={handleCategoryChange}
      />
      <div className="mt-5" />
      <Selector
        title="Associations"
        selected={filter.conditions}
        options={[
          'Allergy',
          'Asthma',
          'Colic',
          'Dairy Sensitivity',
          'Dermatitis',
          'Diarrhea',
          'Eczema',
          'Inflammation',
        ]}
        onChange={handleAssociationsChanged}
      />
    </div>
  );
};
